<template lang="pug">
  div(class="billing-plans-comparing-table")
    div(class="billing-plans-comparing-table__header")
      div(class="text-12px fw-300") {{ header }}
    div(class="billing-plans-comparing-table__body")
      div(
        v-for="(row, idx) in rows"
        :key="idx"
        class="billing-plans-comparing-table__row"
      )
        div(
          class="billing-plans-comparing-table__row-title text-12px fw-500 dark"
          :class="[xsDevice ? 'px-2' : 'px-6']"
        ) {{ row.title }}
        div(
          v-for="(column, idx) in row.columns"
          :key="idx"
          class="text-12px fw-300"
          :class="[xsDevice ? 'px-2' : 'px-6']"
        )
          template(v-if="column === 'check'")
            e-svg-icon(name="check-black")
          template(v-else) {{ column }}
</template>

<script>
import responsive from '~/mixins/pages/responsive'
export default {
  name: 'BillingPlansComparingTable',
  mixins: [responsive],
  props: {
    header: {
      type: String,
      default: null
    },
    rows: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">
.billing-plans-comparing-table {
  &__header {
    display: grid;
    grid-template-columns: 1fr;

    padding: 16px 12px;
    border-bottom: 1px solid #e3e3e3;

    @media (min-width: map-get($breakpoints, 'sm')) {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      padding: 16px 24px;
    }
  }

  &__row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 10px 0;

    &:not(:last-child) {
      border-bottom: 1px solid #e3e3e3;
    }

    @media (min-width: map-get($breakpoints, 'sm')) {
      padding: 18px 0;
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  }

  &__row-title {
    grid-column: span 3;
    padding-bottom: 16px;

    @media (min-width: map-get($breakpoints, 'sm')) {
      grid-column: 1;
      padding-bottom: 0;
    }
  }
}
</style>
